var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none",
    rx: 0,
    ry: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97006 8.39992H20.7701C21.1001 8.39992 21.3701 8.12992 21.3701 7.79992C21.3701 7.46992 21.1001 7.19992 20.7701 7.19992H3.97006C3.64006 7.19992 3.37006 7.46992 3.37006 7.79992C3.37006 8.12992 3.64006 8.39992 3.97006 8.39992ZM16.7701 12.6001H3.97006C3.64006 12.6001 3.37006 12.3301 3.37006 12.0001C3.37006 11.6701 3.64006 11.4001 3.97006 11.4001H16.7701C17.1001 11.4001 17.3701 11.6701 17.3701 12.0001C17.3701 12.3301 17.1001 12.6001 16.7701 12.6001ZM12.7701 16.8001H3.97006C3.64006 16.8001 3.37006 16.5301 3.37006 16.2001C3.37006 15.8701 3.64006 15.6001 3.97006 15.6001H12.7701C13.1001 15.6001 13.3701 15.8701 13.3701 16.2001C13.3701 16.5301 13.1001 16.8001 12.7701 16.8001Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.3533d7197db1ee6c0011bd5b34e12481.svg";
export { ForwardRef as ReactComponent };